var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-not-found"},[_c('img',{attrs:{"src":"/svg/404.svg","width":"300px"}}),_c('mu-title',{attrs:{"color":"primary"}},[_vm._v("Ocorreu um erro interno")]),_c('p',[_vm._v("Desculpe, mas a página que você tentou não pode ser visualizada.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }